module.exports = __webpack_public_path__ + "img/logo-believe-loans.66b883b7.svg";